import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-card-icon',
  templateUrl: './menu-card-icon.component.html',
  styleUrls: ['./menu-card-icon.component.scss']
})
export class MenuCardIconComponent implements OnInit {

  @Input() title: string | undefined;
  @Input() subTitle: string | undefined;
  @Input() icon: string | undefined;

  constructor() { }

  ngOnInit() {
  }

}
